import _ from 'lodash';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import config from '../config';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

const imStore = state => state[config.reduxStoreName].imStore;

const currentMessageListSelector = createSelector(imStore, imStore => imStore.currSessionMsgs);
const getIndex = (_, props) => props.index;
export const messageSelector = createSelector(
    [currentMessageListSelector, getIndex],
    (messageList, index) => messageList[index]
);
